module.exports = __webpack_public_path__ + "static/media/image3.856ba718.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/image3.jpg
// module id = 648
// module chunks = 0